function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 420.039c47.998 0 47.998-72.813 95.996-72.813 47.999 0 47.999 72.813 95.998 72.813 48.001 0 48.001-72.813 96.003-72.813 48.001 0 48.001 72.813 96.003 72.813"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 406.17c47.998 0 47.998-72.813 95.996-72.813 47.999 0 47.999 72.813 95.998 72.813 48.001 0 48.001-72.813 96.003-72.813 48.001 0 48.001 72.813 96.003 72.813"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 392.3c47.998 0 47.998-72.813 95.996-72.813 47.999 0 47.999 72.813 95.998 72.813 48.001 0 48.001-72.813 96.003-72.813 48.001 0 48.001 72.813 96.003 72.813"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 378.431c47.998 0 47.998-72.813 95.996-72.813 47.999 0 47.999 72.813 95.998 72.813 48.001 0 48.001-72.813 96.003-72.813 48.001 0 48.001 72.813 96.003 72.813"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 364.562c47.998 0 47.998-72.812 95.996-72.812 47.999 0 47.999 72.812 95.998 72.812 48.001 0 48.001-72.812 96.003-72.812 48.001 0 48.001 72.812 96.003 72.812"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 350.694c47.998 0 47.998-72.813 95.996-72.813 47.999 0 47.999 72.813 95.998 72.813 48.001 0 48.001-72.813 96.003-72.813 48.001 0 48.001 72.813 96.003 72.813"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 336.825c47.998 0 47.998-72.813 95.996-72.813 47.999 0 47.999 72.813 95.998 72.813 48.001 0 48.001-72.813 96.003-72.813 48.001 0 48.001 72.813 96.003 72.813"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 322.956c47.998 0 47.998-72.812 95.996-72.812 47.999 0 47.999 72.812 95.998 72.812 48.001 0 48.001-72.812 96.003-72.812 48.001 0 48.001 72.812 96.003 72.812"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 309.087c47.998 0 47.998-72.812 95.996-72.812 47.999 0 47.999 72.812 95.998 72.812 48.001 0 48.001-72.812 96.003-72.812 48.001 0 48.001 72.812 96.003 72.812"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 295.217c47.998 0 47.998-72.811 95.996-72.811 47.999 0 47.999 72.811 95.998 72.811 48.001 0 48.001-72.811 96.003-72.811 48.001 0 48.001 72.811 96.003 72.811"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 281.348c47.998 0 47.998-72.813 95.996-72.813 47.999 0 47.999 72.813 95.998 72.813 48.001 0 48.001-72.813 96.003-72.813 48.001 0 48.001 72.813 96.003 72.813"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 267.48c47.998 0 47.998-72.814 95.996-72.814 47.999 0 47.999 72.813 95.998 72.813 48.001 0 48.001-72.813 96.003-72.813 48.001 0 48.001 72.813 96.003 72.813"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 253.61c47.998 0 47.998-72.813 95.996-72.813 47.999 0 47.999 72.813 95.998 72.813 48.001 0 48.001-72.813 96.003-72.813 48.001 0 48.001 72.813 96.003 72.813"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 239.74c47.998 0 47.998-72.812 95.996-72.812 47.999 0 47.999 72.813 95.998 72.813 48.001 0 48.001-72.813 96.003-72.813 48.001 0 48.001 72.813 96.003 72.813"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 225.872c47.998 0 47.998-72.813 95.996-72.813 47.999 0 47.999 72.813 95.998 72.813 48.001 0 48.001-72.813 96.003-72.813 48.001 0 48.001 72.813 96.003 72.813"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 212.003c47.998 0 47.998-72.813 95.996-72.813 47.999 0 47.999 72.813 95.998 72.813 48.001 0 48.001-72.813 96.003-72.813 48.001 0 48.001 72.813 96.003 72.813"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 198.133c47.998 0 47.998-72.813 95.996-72.813 47.999 0 47.999 72.814 95.998 72.814 48.001 0 48.001-72.813 96.003-72.813 48.001 0 48.001 72.813 96.003 72.813"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 184.264c47.998 0 47.998-72.813 95.996-72.813 47.999 0 47.999 72.813 95.998 72.813 48.001 0 48.001-72.813 96.003-72.813 48.001 0 48.001 72.813 96.003 72.813"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 170.395c47.998 0 47.998-72.813 95.996-72.813 47.999 0 47.999 72.813 95.998 72.813 48.001 0 48.001-72.813 96.003-72.813 48.001 0 48.001 72.813 96.003 72.813"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 156.527c47.998 0 47.998-72.813 95.996-72.813 47.999 0 47.999 72.813 95.998 72.813 48.001 0 48.001-72.813 96.003-72.813 48.001 0 48.001 72.813 96.003 72.813"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 142.658c47.998 0 47.998-72.813 95.996-72.813 47.999 0 47.999 72.813 95.998 72.813 48.001 0 48.001-72.813 96.003-72.813 48.001 0 48.001 72.813 96.003 72.813"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 128.789c47.998 0 47.998-72.813 95.996-72.813 47.999 0 47.999 72.813 95.998 72.813 48.001 0 48.001-72.813 96.003-72.813 48.001 0 48.001 72.813 96.003 72.813"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 114.92c47.998 0 47.998-72.813 95.996-72.813 47.999 0 47.999 72.813 95.998 72.813 48.001 0 48.001-72.813 96.003-72.813 48.001 0 48.001 72.813 96.003 72.813"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 101.05c47.998 0 47.998-72.813 95.996-72.813 47.999 0 47.999 72.814 95.998 72.814 48.001 0 48.001-72.814 96.003-72.814 48.001 0 48.001 72.814 96.003 72.814"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 87.181c47.998 0 47.998-72.813 95.996-72.813 47.999 0 47.999 72.813 95.998 72.813 48.001 0 48.001-72.813 96.003-72.813 48.001 0 48.001 72.813 96.003 72.813"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 73.312C47.998 73.312 47.998.5 95.996.5c47.999 0 47.999 72.813 95.998 72.813C239.995 73.312 239.995.5 287.997.5 335.998.5 335.998 73.312 384 73.312"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 384 421"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26);
};

export default __webpack_public_path__ + "static/media/parallel-lines.47c8a0c8.svg";
export { SvgComponent as ReactComponent };